import {
    GET_RATE_LIST_PROGRESS, GET_RATE_LIST_SUCCESS, GET_RATE_LIST_FAILURE,
    ADD_RATE_PROGRESS, ADD_RATE_SUCCESS, ADD_RATE_FAILURE,
    EDIT_DELETE_RATE_PROGRESS, EDIT_DELETE_RATE_SUCCESS, EDIT_DELETE_RATE_FAILURE,

    RESET_MESSAGE,

} from '../../types/actionTypes';

const initialState = {
    rate: [],
    loginUser: null,
    error: false,
    loading: false,
    message: null
}

const rate_reducer = (state = initialState, action) => {
    switch (action.type) {

        case GET_RATE_LIST_SUCCESS:
            return { ...state, rate: action.rate, loading: false };
        case GET_RATE_LIST_FAILURE:
            return { ...state, loading: false, error: true };
        case GET_RATE_LIST_PROGRESS:
            return { ...state, loading: true, error: false };

        case ADD_RATE_PROGRESS:
            return { ...state, loading: true };
        case ADD_RATE_SUCCESS:
            return { ...state, rate: [...state.rate, action.payload], loading: false, error: false, message: action.payload.message };
        case ADD_RATE_FAILURE:
            return { ...state, loading: false, error: action.payload, message: action.payload.message };

        case EDIT_DELETE_RATE_PROGRESS:
            return { ...state, loading: true };
        case EDIT_DELETE_RATE_SUCCESS:
            return {
                ...state,
                rate: state.rate.map((rate) =>
                    rate.id === action.payload.id ? action.payload : rate
                ),
                message: action.payload.message
            };
        case EDIT_DELETE_RATE_FAILURE:
            return { ...state, loading: false, error: action.payload, message: action.payload.message };

        case RESET_MESSAGE:
            return { ...state, message: null };

        default:
            return state
    }
}

export default rate_reducer;